export const READ_STORY_STREAM = 'READ_STORY_STREAM';
export const LOAD_MORE_NEWS = 'LOAD_MORE_NEWS';

export const readStoryStream = siteCode => ({
  type: READ_STORY_STREAM,
  payload: {
    siteCode,
  },
});

export const loadMoreNews = link => ({
  type: LOAD_MORE_NEWS,
  payload: {
    link,
  },
});
